"use strict";

exports.__esModule = true;
exports.getFinalValue = void 0;
var _useDetail = require("./useDetail");
/**
 * 获取props透传的value并转化为 string 或[]<string> 形式，无论是否开启useDetailValue，都支持传入 string 或 object 两种数据形式
 * @param props
 * @returns
 */
var getFinalValue = function getFinalValue(props) {
  var value = props.value,
    defaultValue = props.defaultValue,
    iso = props.iso,
    showTopLevel = props.showTopLevel,
    maxLevel = props.maxLevel,
    multiple = props.multiple,
    useDetailMap = props.useDetailMap,
    useDetailValue = props.useDetailValue;
  var v = 'value' in props ? value : defaultValue;
  v = (0, _useDetail.transferObjToAvailable)(v, {
    iso: iso,
    showTopLevel: showTopLevel,
    maxLevel: maxLevel,
    multiple: multiple,
    useDetailMap: useDetailMap,
    useDetailValue: useDetailValue
  });
  return v;
};
exports.getFinalValue = getFinalValue;